(function () {
    'use strict';

    angular.module("imApp").factory("subscriptionLineService", ['$ihttp', function ($ihttp) {
        let service = {
            getSetting: function (parms) {
                return $ihttp.post({
                    method: 3230,
                    parameters: parms || {}
                });
            },
            listPriceIndexes: function (parms) {
                return $ihttp.post({
                    method: 3231,
                    parameters: parms || {}
                });
            },
            listAdjustedQuantities: function (parms) {
                return $ihttp.post({
                    method: 3232,
                    parameters: parms || {}
                });
            },
            listAdjustedPrices: function (parms) {
                return $ihttp.post({
                    method: 3233,
                    parameters: parms || {}
                });
            },
            listDataIndexes: function (parms) {
                return $ihttp.post({
                    method: 3234,
                    parameters: parms || {}
                });
            },
            recalcColumn: function (edit) {
                return $ihttp.post({
                    method: 3236,
                    parameters: edit
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 3235,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
